import React from "react";
import Misc from "../../../assets/misc/5.svg";
import Play from "../../../assets/icons/play.svg";
import Marker from "../../../assets/icons/marker.svg";
import Display from "../../../assets/icons/display.svg";
import Video1 from "../../../assets/video/1.png";
import Video2 from "../../../assets/video/2.png";
import Video3 from "../../../assets/video/3.png";
import Carousel from "react-multi-carousel";
import Button from "../../common/Button";
import "react-multi-carousel/lib/styles.css";

const UpcomingWebinar = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    }
  };

  const items = [
    {
      title: "Introduction to the Competition",
      period: "2022, 19th October 10:00am (EST)",
      location: "",
      display: "Virtual",
      link: "https://www.youtube.com/watch?v=Zrr_TPXMntU",
      video: Video1,
      type: "video",
    },
    {
      title: "Overview of PET Frameworks",
      period: "2022, 26th October 10:00am (EST)",
      location: "",
      display: "Virtual",
      link: "https://www.youtube.com/watch?v=BDYjZUCEUog",
      video: Video2,
      type: "video",
    },
    {
      title: "Ready, set, go!",
      period: "2022, 8th November",
      location: "Yogyakarta, Indonesia",
      video: Video3,
      type: "meet",
    },
  ];

  return (
    <div className="w-full">
      <div className="flex items-center justify-between md:mb-[100px] mb-16 flex-col md:flex-row gap-10 text-center">
        <p className="relative">
          <span className="inline-flex w-full max-w-[288px] font-semibold md:text-[40px] text-3xl leading-tight text-dark">
            Upcoming Webinars
          </span>
          <img
            src={Misc}
            className="absolute md:-right-5 -top-9 right-2 scale-90 sm:scale-100"
            alt=":( Not Found"
          />
        </p>
        <p className="w-full max-w-[503px] text-xl leading-normal text-dark opacity-70">
          All webinars will be recorded and made available online, but
          participants are encouraged to join and participate in live Q&A
        </p>
      </div>

      <div className="w-full justify-between lg:flex hidden">
        {items.map((item, index) => (
          <div key={index} className="w-full max-w-[324px]">
            <div className="relative mb-6 select-none rounded-3xl h-[11rem] flex items-start justify-center overflow-hidden">
              {item.link && <div className=" absolute top-0 left-0 w-full h-full bg-white bg-opacity-40 flex justify-center items-center">
                <Button type="submit" className="" onClick={() => window.open(item.link, "_blank")} >
                {item.type === "video" ? "Watch" : "Join"}
                </Button>
              </div>}
              
              <img src={item.video} alt="item.title" />
              {/* <img
                src={Play}
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
                alt=":( Not Found"
              /> */}
            </div>
            <div>
              <p className="font-semibold text-sm leading-5 text-warning mb-4">
                {item.period}
              </p>
              <p className="font-semibold text-xl leading-normal text-dark mb-4">
                {item.title}
              </p>
              {item.location && <p className="flex items-start mb-2">
                <img
                  src={Marker}
                  className="flex-shrink-0 mr-3"
                  alt="location"
                />
                <span className="font-semibold text-sm text-dark opacity-60">
                  {item.location}
                </span>
              </p>}
              {item.display && (
                <p className="flex items-start mb-2">
                  <img
                    src={Display}
                    className="flex-shrink-0 mr-3"
                    alt="display"
                  />
                  <span className="font-semibold text-sm text-dark opacity-60">
                    {item.display}
                  </span>
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
      
      <div className="w-full lg:hidden webinar-carousel">
        <Carousel
          responsive={responsive}
          showDots={true}
          // dotListClass="custom-dot-list-style"
          itemClass="carousel-item"
          arrows={false}
        >
          {items.map((item, index) => (
            <div key={index} className=" mb-10 flex-col flex mx-auto w-[85%]">
              <div className="relative mb-6 select-none rounded-3xl h-[11rem] flex items-center justify-center overflow-hidden">
                {item.link && <div className=" absolute top-0 left-0 w-full h-full bg-white bg-opacity-40 flex justify-center items-center">
                  <Button type="submit" className=" px-5 py-3 text-sm sm:px-7 sm:py-4 sm:text-base" onClick={() => window.open(item.link, "_blank")} >
                  {item.type === "video" ? "Watch" : "Join"}
                  </Button>
                </div>}
                
                <img src={item.video} alt="item.title" />
                {/* <img
                  src={Play}
                  className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
                  alt=":( Not Found"
                /> */}
              </div>
              <div className="flex flex-col">
                <p className="font-semibold text-sm leading-5 text-warning mb-4">
                  {item.period}
                </p>
                <p className="font-semibold text-xl leading-normal text-dark mb-4">
                  {item.title}
                </p>
                <p className="flex items-start mb-2">
                  <img
                    src={Marker}
                    className="flex-shrink-0 mr-3"
                    alt="location"
                  />
                  <span className="font-semibold text-sm text-dark opacity-60">
                    {item.location}
                  </span>
                </p>
                {item.display && (
                  <p className="flex items-start mb-2">
                    <img
                      src={Display}
                      className="flex-shrink-0 mr-3"
                      alt="display"
                    />
                    <span className="font-semibold text-sm text-dark opacity-60">
                      {item.display}
                    </span>
                  </p>
                )}
              </div>
            </div>
          ))}
        </Carousel>
      </div>
      
    </div>
  );
};

export default UpcomingWebinar;
